import api from './api';

export const activoFinanceService = {
  async getDepreciationSummary(params = {}) {
    const response = await api.get('/activos/reports/depreciation', { params });
    return response.data;
  },
  async getDepreciationByArea(params = {}) {
    const response = await api.get('/activos/reports/depreciation-by-area', { params });
    return response.data;
  },
  async getDepreciationByPeriod(params = {}) {
    const response = await api.get('/activos/reports/depreciation-by-period', { params });
    return response.data;
  },
  async getDepreciationByYear(params = {}) {
    const response = await api.get('/activos/reports/depreciation-by-year', { params });
    return response.data;
  },
  async getDepreciationSchedule(id) {
    const response = await api.get(`/activos/reports/depreciation/${id}/schedule`);
    return response.data;
  },
};

export default activoFinanceService;
